import { DescriptionOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import { School, SchoolSales } from "lib/models";
import { ClassNames, StageName, StageType } from "lib/types";
import { cn, getYear } from "lib/utils";
import { Link } from "react-router-dom";

const SchoolListPage = ({
  schoolList,
  schoolGradeCnt,
  popupSchoolSales,
  me,
  years,
}: {
  schoolList: School[];
  schoolGradeCnt: number;
  popupSchoolSales: (
    e: React.MouseEvent,
    school: School,
    sales?: SchoolSales
  ) => void;
  me: any;
  years: number[];
}) => {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 border-solid shadow-sm">
    <div className="min-w-[900px]">
      <div
        className={cn(
          "grid items-center pb-2 pt-3 pr-6 text-center bg-gray-50 text-gray-500 font-medium border-b border-gray-200 border-solid",
          schoolGradeCnt === 3 ? "grid-cols-custom-5" : "grid-cols-custom-8"
        )}
      >
        <div>학교이름</div>
        <div>전화번호</div>
        <div>홈페이지</div>
        <div>주소</div>
        <div>전체</div>
        {schoolGradeCnt > 0 && <div>1학년</div>}
        {schoolGradeCnt > 1 && <div>2학년</div>}
        {schoolGradeCnt > 2 && <div>3학년</div>}
        {schoolGradeCnt > 3 && <div>4학년</div>}
        {schoolGradeCnt > 4 && <div>5학년</div>}
        {schoolGradeCnt > 5 && <div>6학년</div>}
      </div>
      {schoolList.map((school: School) => (
        <div key={school.id}>
          <div
            className={cn(
              "grid items-center bg-white hover:bg-indigo-50 cursor-pointer py-3 pl-8 border-t border-solid border-gray-200",
              schoolGradeCnt === 3 ? "grid-cols-custom-5" : "grid-cols-custom-8"
              // school.schoolSales?.length > 0
              //   ? " border-solid border-l-2 border-orange-500"
              //   : ""
            )}
            onClick={(e) => popupSchoolSales(e, school)}
          >
            <div className="font-semibold">{school.name}</div>
            <div>{school.phone}</div>
            <div>
              <Link to={school.homepage} target="_blank">
                {school.homepage}
              </Link>
            </div>
            <div>{school.address}</div>
            <div>
              {school.grade1ClassCnt +
                school.grade2ClassCnt +
                school.grade3ClassCnt +
                school.grade4ClassCnt +
                school.grade5ClassCnt +
                school.grade6ClassCnt}
            </div>
            {schoolGradeCnt > 0 && <div>{school.grade1ClassCnt}</div>}
            {schoolGradeCnt > 1 && <div>{school.grade2ClassCnt}</div>}
            {schoolGradeCnt > 2 && <div>{school.grade3ClassCnt}</div>}
            {schoolGradeCnt > 3 && <div>{school.grade4ClassCnt}</div>}
            {schoolGradeCnt > 4 && <div>{school.grade5ClassCnt}</div>}
            {schoolGradeCnt > 5 && <div>{school.grade6ClassCnt}</div>}
            {schoolGradeCnt > 6 && <div>{school.studentCompose}</div>}
          </div>
          {school.schoolSales
            .filter((s) => years.includes(getYear(s.classDateFrom)))
            .map((sales, idx) => (
              <div
                key={sales.id}
                className={cn("py-1 pl-10 pr-5", "")}
                onClick={(e: any) => popupSchoolSales(e, school, sales)}
              >
                <div className="grid grid-cols-[80px_70px_140px_60px_120px_1fr] items-center gap-x-5 p-1 bg-gray-50 hover:bg-gray-100 rounded-sm cursor-pointer">
                  <div
                    className={cn(
                      sales.isFree
                        ? "bg-red-600 text-xs"
                        : sales.stage === StageType.NONE
                        ? "bg-[#dddddd]"
                        : sales.stage === StageType.CONTACT
                        ? "bg-[#8892dc]"
                        : sales.stage === StageType.VISIT_APPOINTMENT
                        ? "bg-[#334bb5]"
                        : sales.stage === StageType.VISIT
                        ? "bg-[#3962ca]"
                        : sales.stage === StageType.ESTIMATE
                        ? "bg-[#5243b1]"
                        : sales.stage === StageType.CONTRACT_COMPLETED
                        ? "bg-[#0dcd63]"
                        : sales.stage === StageType.CLASS_ASSIGNED
                        ? "bg-[#008c13]"
                        : sales.stage === StageType.CLASS_COMPLETED
                        ? "bg-[#878787]"
                        : "bg-[#454545]",
                      "text-white px-2 py-1 rounded-sm text-center"
                    )}
                  >
                    {sales.isFree && "무료"}
                    {StageName[sales.stage]}
                  </div>
                  <div>{sales.user.name}</div>
                  <div>
                    {sales && sales.stage >= StageType.CONTRACT_COMPLETED && (
                      <>
                        수업일 :{" "}
                        {dayjs(sales.classDateFrom)
                          .toDate()
                          .toLocaleDateString() ?? ""}
                      </>
                    )}
                  </div>
                  <div> ({sales.classTimes}교시)</div>
                  <div>
                    {sales.classType > 0 && sales.contractCnt > 0 && (
                      <div>{`${ClassNames[sales.classType - 1]}: ${
                        sales.contractCnt
                      }학급`}</div>
                    )}
                  </div>
                  <div className="overflow-hidden">
                    {sales.memo.length > 0 && (
                      <div>
                        <DescriptionOutlined fontSize="small" /> {sales.memo}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      ))}
    </div>
    </div>
  );
};

export default SchoolListPage;
